import { Page } from '@/core/architecture'

import { StoreCartListTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreCartList Page
 * Implemented as a practical sample.
 */
export const StoreCartList: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreCartListTemplate state={state} {...actions} />
}
